import * as Types from '../../constants/actionTypes';

const defaultState = {
  requestCarrierLabels: {},
  requestDetailsList: []
}
export default (state = defaultState, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {
    case Types.REQUEST_DETAILS:
      return {
        ...state,
        requestDetailsList: action.data.data,
      }
    case Types.REQUEST_DETAILS_COUNT:
      return {
        ...state,
        requestDetailsCount: action.data.data,
      }
    case Types.HOME_CUSTOMER_REQUEST_TYPES:
      return {
        ...state,
        homeCustomerRequestTypes: action.data.data,
      }
    case Types.REQUEST_SUCCESS:
      return {
        ...state,
        addedRequest: action.data.data,
      }
    case Types.REQUEST_SUCCESS_MESSAGE:
      return {
        ...state,
        integerationMessage: action.data.message,
      }
    case Types.COLLECTION_ADDRESS_SUCCESS:
      return {
        ...state,
        collectionAddressDetails: action.data.data,
      }
    case Types.PORTAL_COUNTRIES:
      return {
        ...state,
        homecustomerCountries: action.data.data,
      }
    case Types.PORTAL_ASSETS:
      return {
        ...state,
        homecustomerAssets: action.data.data,
      }
    case Types.HOME_BRANDS:
      return {
        ...state,
        homeBrands: action.data.data,
      }
    case Types.USER_DETAILS_BY_USER_ID:
      return {
        ...state,
        singleUserDetails: action.data,
      }

    case Types.PORTAL_STATUSES:
      return {
        ...state,
        homePortalStatuses: action.data.data,
      }
    case Types.COLLECTION_ADDRESS_DETAILS:
      return {
        ...state,
        allCollectionAddressDetails: action.data.data,
      }

    case Types.REQUEST_DETAILS_BY_REQUESTID:
      return {
        ...state,
        requestDetailsByRequestId: action.data.data,
      }

    case Types.REQUEST_CARRIER_LABELS:
      const keyName = `request_${action.requestId}`
      const requestCarrierLabels = state.requestCarrierLabels
      requestCarrierLabels[keyName] = action.data
      return {
        ...state,
        requestCarrierLabels
      }

    case Types.REQUEST_CARRIER_LABELS_ERROR:
      return {
        ...state,
        requestCarrierLabelError: action.errorMessage
      }

    case Types.USER_DETAILS:
      return {
        ...state,
        usersList: action.data.data,
      }
    case Types.USER_SUCCESS:
      return {
        ...state,
        userDetails: action.data.data,
      }
    case Types.USER_FAILED:
      return {
        ...state,
        userDetailsError: action.errorMessage,
      }
    case Types.REQUEST_FAILED:
      return {
        ...state,
        requestDetailsError: action.errorMessage && action.errorMessage,
      }
    case Types.UPLOAD_BULK_REQUESTS:
      return {
        ...state,
        bulkUploadStatus: action.bulkUploadStatus,
      }
    case Types.BULK_USERS_ERROR:
      return {
        ...state,
        bulkUserError: action.addressError,
      }
    case Types.COGNITO_USER_DETAILS:
      return {
        ...state,
        cognitoUser: action.data.cognitoUser,
        username: action.data.username,
      }
    case Types.COGNITO_USER_DETAILS_FAILED:
      return {
        ...state,
        userError: action.errorMessage.message,
      }
    case Types.USER_LOGIN_DETAILS:
      return {
        ...state,
        loginData: action.data,
      }
    case Types.INITIATE_UNAUTHORIZED_ACCESS_FOR_HOME_USER:
      return {
        ...state,
        notAllowedToEnterHomeCustomerPortal: true
      }
    case Types.PROGRAM_DATA:
      return {
        ...state,
        programData: action.programData
      }
    case Types.PROGRAM_ERROR:
      return {
        ...state,
        programError: action.programError
      }
    case Types.USER_ACCESS_TOKEN:
      return {
        ...state,
        tokenData: action.payload.data
      }
    case Types.IS_HOME_USER_AUTHENTICATED: {
      delete state.refreshToken
      delete state.token
      return {
        ...state,
        isHomeUserAuthenticated: action.isHomeUserAuthenticated
      }
    }
    case Types.CULTURES_DETAIL_SUCCESS:
      return {
        ...state,
        programCulturesList: action.payload
      }
    case Types.CULTURES_DETAIL_ERROR:
      return {
        ...state,
        cultureDetailError: action.cultureDetailError
      }
    default:
      return state;
  }


};